import type { FC } from 'react';
import React from 'react';
import type { IIconProps } from '@/Module/Icon/Model';
import { BaseIcon } from './BaseIcon';
export const IconProfileUsual: FC<IIconProps> = props => {
  return <BaseIcon {...props} data-sentry-element="BaseIcon" data-sentry-component="IconProfileUsual" data-sentry-source-file="IconProfileUsual.tsx">
      <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="IconProfileUsual.tsx">
        <rect x="1.7998" y="1" width="20" height="20" rx="7" fill="#E8F1FE" stroke="#BAD6FB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="rect" data-sentry-source-file="IconProfileUsual.tsx" />
        <ellipse cx="6.56406" cy="17" rx="1.9" ry="1.75" fill="#474A57" data-sentry-element="ellipse" data-sentry-source-file="IconProfileUsual.tsx" />
      </svg>
    </BaseIcon>;
};